 
// @mui material components
import Grid from "@mui/material/Grid";
 
// Material Dashboard 2 React components
import MDBox from "components/MDBox"; 
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReportedUsers from "./ReportedUsers";
 
function ReportedUsersScreen() {
 
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
        <ReportedUsers/>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ReportedUsersScreen;
